import { PERMISSIONS } from '@base/shared';
import { useTranslation } from 'react-i18next';
import { logout, useMe } from '../auth.tsx';

/**
 * Entrou sem a segunda etapa e tem permissões sensíveis (S2, ADR 0020): elas ficam retidas. Só
 * aparece quando o servidor exige a segunda etapa (AUTH_MFA_AMR), o que o login simples não faz.
 */
export function MfaNotice() {
  const { t, i18n } = useTranslation();
  const me = useMe();
  const mfa = me.data?.mfa;
  if (!mfa || mfa.verified || mfa.withheld.length === 0) return null;
  const lang = i18n.language === 'en' ? 'en' : 'pt-BR';
  const labels = mfa.withheld.map(
    (code) => PERMISSIONS.find((p) => p.code === code)?.label[lang] ?? code,
  );
  return (
    <div
      role="status"
      className="flex flex-col gap-2 rounded-lg border border-rule bg-brand-soft p-4 text-sm text-ink"
    >
      <p className="font-medium">{t('mfa.title')}</p>
      <p>{t('mfa.body')}</p>
      <ul className="ml-5 list-disc text-muted">
        {labels.map((l) => (
          <li key={l}>{l}</li>
        ))}
      </ul>
      <p>{t('mfa.howTo')}</p>
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => void logout()}
          className="inline-flex min-h-10 items-center rounded-md border border-control-border bg-sheet px-4 py-2 font-medium text-ink hover:border-ink"
        >
          {t('mfa.relogin')}
        </button>
      </div>
    </div>
  );
}
